import './gridSearchInput.less';

import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { AntInput } from 'controls/react/ant/antInput';
import { linkModel } from 'framework/mobx-integration';
import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { getStore, GridStoreHolder } from 'controls/grid/utils/getStore';
import b_ from 'b_';
import { i18n } from 'core/localization';

const b = b_.with('grid-search-input');

export type GridSearchInputProps<T extends GridDataEntry> = {
	store: GridStoreHolder<T>;
	placeholder?: string;
	searchSource?: 'rows' | 'columns';
};

export const GridSearchInput = observer(<T extends GridDataEntry>(props: GridSearchInputProps<T>) => {
	const store = getStore(props.store);
	const searchSource = props.searchSource == 'columns' ? store?.columns : store?.state;

	if (!store?.selfInitialized || !searchSource) return null;

	const classes = classNames(b({ active: !!searchSource?.searchString }), '_bypass-dirty-check');

	return (
		<AntInput
			placeholder={props.placeholder ?? i18n('Search...')}
			size={'small'}
			bounced={1000}
			className={classes}
			{...linkModel(searchSource, 'searchString')}
		/>
	);
});
